import { useFormatDate } from "src/internationalization";

export const useGetScenarioCodePlaceholderExample = () => {
  const formatDate = useFormatDate();

  const getScenarioCodePlaceholderExample = () => {
    return `${formatDate(new Date(), {
      month: "short",
    }).toLowerCase()}-${new Date().getFullYear()}`.replace(".", "");
  };

  return getScenarioCodePlaceholderExample;
};
